module.exports = __webpack_public_path__ + "img/sysmo-icon-v2.7c1179eb.png";